import React, { useCallback, useEffect, useState } from 'react'

import { useSelector } from 'react-redux'
import Colors from 'utils/Colors'
import { assessorsResponseTimeSLA } from 'services/apiKYP'
import DataLoadErrorCard from '../DataLoadErrorCard'
import BarChart from '../BarChart'
import { monthToAbbr } from '../../../utils/functions'


const initialState = {
  labels: [],
  datasets: [
    {
      label: 'Tempo mínimo',
      backgroundColor: Colors.approved,
      borderColor: Colors.approved,
      borderWidth: 1,
      data: [],
    },
    {
      label: 'Tempo médio',
      backgroundColor: Colors.info,
      borderColor: Colors.info,
      borderWidth: 1,
      data: [],
    },
    {
      label: 'Tempo máximo',
      backgroundColor: Colors.red,
      borderColor: Colors.red,
      borderWidth: 1,
      data: [],
    },
  ],
}

const AssessorsResponseTimeSLAChart = ({ startDate, endDate, shouldFetchData }) => {
  const token = useSelector((state) => state.auth.access_token)

  const [chartData, setChartData] = useState(initialState)
  const [isLoading, setIsLoading] = useState(true)
  const [fetchError, setFetchError] = useState(null)

  const title = 'SLA de Resposta de Assessores em dias utéis'

  const initializeData = (data) => {
    const labels = data?.stats?.map(d => `${monthToAbbr(d.month)}/${d.year}`)
    const updatedData = { ...chartData }

    updatedData.datasets[0].data = data?.stats?.map(d => d.minimum) || []
    updatedData.datasets[1].data = data?.stats?.map(d => d.average) || []
    updatedData.datasets[2].data = data?.stats?.map(d => d.maximum) || []
    updatedData.labels = labels

    setChartData(updatedData)
  }

  const fetchData = useCallback(() => {
    if (!startDate || !endDate || new Date(startDate) > new Date(endDate)) {
      return
    }

    setFetchError(null)
    setIsLoading(true)

    const params = {
      start_date: startDate,
      end_date: endDate,
    }

    assessorsResponseTimeSLA(token, params)
      .then((response) => {
        const { data } = response
        initializeData(data)
      })
      .catch((error) => {
        if (error.response && error.response.data.message) {
          setFetchError(error.response.data.message)
        } else {
          setFetchError('Não conseguimos acessar os dados no momento. Por favor, tente novamente.')
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [token, startDate, endDate])

  useEffect(() => {
    if (shouldFetchData) {
      fetchData()
    }
  }, [shouldFetchData])

  return (
    fetchError ? <DataLoadErrorCard message={fetchError} actionCallback={fetchData} title={title} /> : (
      <BarChart
        data={chartData}
        size='medium'
        displayLegend={true}
        title={title}
        isLoading={isLoading}
      />
    )
  )
}


export default AssessorsResponseTimeSLAChart
